import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // Check if coordinator is logged in by verifying both token and session
  const isCoordinatorLoggedIn =
    sessionStorage.getItem('coordinatorToken') !== null &&
    sessionStorage.getItem('isLoggedIn') === 'true';

  /*if (!isCoordinatorLoggedIn) {
    // Redirect to login page with the return URL
    return <Navigate to="/general-login" state={{ from: location }} replace />;
  }*/

  // Check if Author is logged in by verifying both token and session
  const isAuthorLoggedIn =
    sessionStorage.getItem('authorToken') !== null &&
    sessionStorage.getItem('isLoggedIn') === 'true';

  // Check if Author is logged in by verifying both token and session
  const isAdminLoggedIn =
    sessionStorage.getItem('adminToken') !== null &&
    sessionStorage.getItem('isLoggedIn') === 'true';

  if (!isAuthorLoggedIn && !isCoordinatorLoggedIn && !isAdminLoggedIn) {
    // Redirect to login page with the return URL
    return <Navigate to="/general-login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 